import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, of, Observable } from 'rxjs'
import { distinctUntilChanged } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { TokenStorage } from './token-storage';
import { Router } from '@angular/router';


interface State {
  data: any;
  authenticated: boolean;
}

const defaultState: State = {
  data: null,
  authenticated: Boolean(TokenStorage)
};

const store = new BehaviorSubject<State>(defaultState);

class Store {
  private store = store;
  changes = this.store.asObservable().pipe(distinctUntilChanged());

  setState(state: State) {
    this.store.next(state);
  }

  getState(): State {
    return this.store.value;
  }

  updateState(data: State) {
    this.store.next({ ...this.getState(), ...data });
  }

  purge() {
    this.store.next(defaultState);
  }
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private store: Store = new Store();
  public authenticated: boolean = false;
  uname = '';
  private tokenKey = 'Afrisure-Token';
  private loggedIn: BehaviorSubject<boolean>;
  constructor(private http: HttpClient, private jwt: TokenStorage, private router: Router) {
    this.store.setState({
      data: null, authenticated: Boolean(this.jwt.get())
    });
   
    this.loggedIn = new BehaviorSubject<boolean>(this.hasToken());

  }

  isAuthenticated(): Observable<any> {
    if (!this.jwt.get()) {
      return of(null);
    } else {
      return of(Boolean(this.jwt));
    }
  }

  attempAuth(uname: string, password: string): Observable<any> {
    this.uname = uname;
    return of(null)
  }

  b2cAttemptAuth(data: any): Observable<any> {
    this.jwt.save(data);
    this.authenticated = Boolean(data);
    return of(
      this.store.setState({
        data: data, authenticated: Boolean(data)
      })
    )
  }

  // customertempAuth(data: any): Observable<any> {
  //   this.jwt.saveCT(data);
  //   this.authenticated = Boolean(data);
  //   return of(
  //     this.store.setState({
  //       data: data, authenticated: Boolean(data)
  //     })
  //   )
  // }

  //Method to store refresh token
  saveRefreshToken(data: any): Observable<any> {

    this.jwt.saveRT(data);

    return of(
      this.store.setState({
        data: data, authenticated: Boolean(data)
      })
    )
  }

  BrowserLogin(): Observable<any> {
   const refreshTokenEndpoint = `${environment.authAPIURL}api/digital/core/Customer/BrowserLogin`;
    return this.http.post<any>(refreshTokenEndpoint, {});
  }
  getAuthState() {
    return this.store.getState();
  }

  logoutUser() {
    this.store.setState({
      data: null, authenticated: false
    });
    return of(
      this.store.setState({
        data: null, authenticated: false
      })
    )
  }
  private hasToken(): boolean {
    return !!localStorage.getItem('customerLogin');
  }

  get   isLoggedIn(): Observable<boolean> {
    return this.loggedIn.asObservable();
  }
  login(): void {
    // localStorage.setItem(this.tokenKey, token);
    this.loggedIn.next(true);
  }

  logout(): void {
    // localStorage.removeItem(this.tokenKey);
    this.loggedIn.next(false);
  }
}
function jwt_decode(token: string) {
  throw new Error('Function not implemented.');
}

